import React, { Component } from "react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Container, Row, Col, Table, Button } from "reactstrap";
import Breadcrumbs from "components/Common/Breadcrumb";
import moment from "moment";
import { getReport } from "store/resultsSubmit/actions";
import logo from "../../assets/images/neqas-logo.jpeg";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
  Label,
  ReferenceLine,
} from "recharts";
const sections = ["report-area"];
class RegReportParticipant extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reportDetails: {},
      selectedAnalyte: null, // Add selectedAnalyte here
      analyteData: [],
      loading: true,
      user_id: localStorage.getItem("authUser")
        ? JSON.parse(localStorage.getItem("authUser")).user_id
        : null, // ✅ Default to null instead of empty string
    };
  }
  componentDidMount() {
    const { id, id1 } = this.props.match.params; // roundId = id, labId = id1
    console.log("Round ID:", id, "Lab ID:", id1); // log to verify
    this.props.onGetReport(id, id1);
  }

  componentDidUpdate(prevProps) {
    const { reportData } = this.props;
    const { selectedAnalyte } = this.state;

    if (prevProps.reportData !== reportData && reportData) {
      const participantId = this.props.match.params.id1;
      console.log("Report Data:", reportData);
      console.log("Looking for participantId:", participantId);

      const participantResults = reportData.participants_results.filter(
        (result) => result.participant_id == participantId
      );

      const zScoreChartData = reportData.graph_data
        ? reportData.graph_data.flatMap((g) =>
            g.z_scores.map((z) => ({
              analyteName: g.analyte_name,
              name: `Participant ${z.participant_id}`,
              ZScore: z.z_score ? parseFloat(z.z_score) : null,
            }))
          )
        : [];

      console.log("Z-Score Chart Data:", zScoreChartData);

      // Get analyte summaries to retrieve accepted result count
      const analyteSummaries = reportData.analyte_result_summary || [];

      const analyteData = participantResults.map((result) => {
        const isNotSubmitted =
          !result.evaluation ||
          result.evaluation.toLowerCase() === "not submitted";

        return {
          analyteName: result.analyte_name ?? "",
          unit: result.unit ?? "--",
          instrument: result.instrument ?? "--",
          count: !isNotSubmitted ? result.lab_count ?? "--" : "--",
          result:
            !isNotSubmitted && result.result !== null ? result.result : "--",
          mean: !isNotSubmitted ? result.mean ?? "--" : "--",
          CV: !isNotSubmitted ? result.CV ?? "--" : "--",
          robust_mean: !isNotSubmitted ? result.robust_mean ?? "--" : "--",
          robust_deviation: !isNotSubmitted
            ? result.robust_deviation ?? "--"
            : "--",
          robust_sd: !isNotSubmitted ? result.robust_sd ?? "--" : "--",
          upper_acceptability_limit: !isNotSubmitted
            ? result.upper_acceptability_limit ?? "--"
            : "--",
          lower_acceptability_limit: !isNotSubmitted
            ? result.lower_acceptability_limit ?? "--"
            : "--",
          zScore: !isNotSubmitted ? result.z_score ?? "--" : "--",
          evaluation: result.evaluation ?? "--",
          acceptedResults: result.accepted_results ?? 0,
          rejectedResults: result.rejected_results ?? 0,
          mu_robust_mean: !isNotSubmitted
            ? result.mu_robust_mean ?? "--"
            : "--",
        };
      });

      let robust_mean = "--";
      let robust_sd = "--";
      if (participantResults.length > 0) {
        robust_mean = participantResults[0].robust_mean || "--";
        robust_sd = participantResults[0].robust_sd || "--";
      }

      const reportDetails = {
        round: reportData.round_name || "--",
        scheme: reportData.scheme_name || "--",
        issueDate: reportData.issue_date || "--",
        closingDate: reportData.closing_date || "--",
        printDate: moment(new Date()).format("DD-MMM-YY"),
        matrix: reportData.matrix || "--",
        cycle: reportData.cycle_no || "--",
        sample: reportData.sample || "--",
        robust_mean: reportData.robust_mean || "--",
        robust_sd: robust_sd,
      };

      this.setState({
        reportDetails,
        analyteData,
        zScoreChartData,
        loading: false,
      });
    }
  }

  handleAnalyteSelection = (analyteName) => {
    this.setState({ selectedAnalyte: analyteName });
  };

  // Utility function to group Z-scores into bins
  groupZScores = (zScores) => {
    const bins = [
      { range: "< -3.0", count: 0 },
      { range: "-3.0 to -2.0", count: 0 },
      { range: "-2.0 to -1.0", count: 0 },
      { range: "-1.0 to +1.0", count: 0 },
      { range: "+1.0 to +2.0", count: 0 },
      { range: "+2.0 to +3.0", count: 0 },
      { range: "> +3.0", count: 0 },
    ];

    zScores.forEach((score) => {
      if (score < -3) {
        bins[0].count++;
      } else if (score >= -3 && score < -2) {
        bins[1].count++;
      } else if (score >= -2 && score < -1) {
        bins[2].count++;
      } else if (score >= -1 && score <= 1) {
        bins[3].count++;
      } else if (score > 1 && score <= 2) {
        bins[4].count++;
      } else if (score > 2 && score <= 3) {
        bins[5].count++;
      } else if (score > 3) {
        bins[6].count++;
      }
    });

    return bins;
  };

  handleDownloadPDF = (round, labId) => {
    const labIdValue = typeof labId === "object" ? labId.id : labId;

    // 🔹 safer way: check multiple possible keys
    let roundNameValue;
    if (typeof round === "object") {
      roundNameValue =
        round.round_name || round.rounds || round.name || round.id || "";
    } else {
      roundNameValue = round || "";
    }

    if (!roundNameValue) {
      console.error("❌ No round name provided, cannot generate URL");
      return;
    }

    fetch(
      `https://externalqcapi.com/api/registration-admin/${encodeURIComponent(
        roundNameValue
      )}/pdf/?lab_id=${labIdValue || ""}`,
      { method: "GET" }
    )
      .then((res) => {
        if (!res.ok) throw new Error(`❌ Network error: ${res.status}`);
        return res.blob();
      })
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `report_${roundNameValue}_${labIdValue || "all"}.pdf`;
        a.click();
        window.URL.revokeObjectURL(url);
      })
      .catch((err) => console.error("❌ PDF download error:", err));
  };

  render() {
    const { reportDetails, analyteData, loading } = this.state;
    const { selectedAnalyte } = this.state;
    const filteredZScoreData = analyteData
      .filter((analyte) =>
        selectedAnalyte
          ? analyte.analyteName.toLowerCase().trim() ===
            selectedAnalyte.toLowerCase().trim()
          : true
      )
      .flatMap((analyte) =>
        this.props.reportData.participants_results
          .filter((result) => result.analyte_name === analyte.analyteName)
          .map((result) => ({
            name: `Participant ${result.participant_id}`,
            analyteName: analyte.analyteName,
            ZScore: result.z_score ? parseFloat(result.z_score) : null,
          }))
      )
      .filter(
        (data) =>
          data.ZScore !== null &&
          data.ZScore !== undefined &&
          !isNaN(data.ZScore)
      );
    const zScores = filteredZScoreData.map((data) => data.ZScore);
    const groupedZScoreBins = this.groupZScores(zScores);
    if (loading) {
      return (
        <Container
          fluid
          className="d-flex justify-content-center align-items-center"
          style={{ height: "80vh" }}
        >
          {/* Reactstrap Spinner */}
          <div className="text-center">
            <div
              className="spinner-border text-primary"
              role="status"
              style={{ width: "3rem", height: "3rem" }}
            >
              <span className="visually-hidden">Loading...</span>
            </div>
            <p className="mt-3 fw-bold text-dark">Loading report...</p>
          </div>
        </Container>
      );
    }
    if (!analyteData.length) {
      return (
        <Container
          fluid
          style={{
            paddingTop: "60px", // Adjust for header height
            paddingBottom: "40px", // Adjust for footer height
          }}
        >
          <Breadcrumbs title="Report" breadcrumbItem="Participant Report" />
          <p className="text-center text-dark p-5 fs-4 fw-bold fst-italic">
            No data available for this participant.
          </p>
        </Container>
      );
    }

    const defaultSorted = [
      {
        dataField: "analyte_name", // or scheme_name, name, etc.
        order: "asc", // A to Z
      },
    ];

    return (
      <Container
        id="report-area" // ✅ added
        fluid
        style={{
          paddingTop: "10%",
          paddingBottom: "10%",
          paddingLeft: "10%",
          paddingRight: "10%",
        }}
      >
        <div className="d-flex justify-content-end mb-3">
          <Button
            className="w-25 no-print btn btn-outline-secondary"
            onClick={() =>
              this.handleDownloadPDF(
                reportDetails.round,
                this.props.match.params.id1
              )
            }
          >
            Download
          </Button>
        </div>

        <style>
          {`@media print {
.no-print { display: none !important; }
  /* General print settings */
  body {
    font-size: 12px;
    line-height: 1.4;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  /* Hide unwanted elements */
  .navbar, .footer, .breadcrumb {
    display: none !important;
  }

  /* First page margins */
  @page :first {
    size: A4;
    margin: 20mm 20mm 20mm 20mm; /* top, right, bottom, left */
  }

  /* Margins for subsequent pages */
  @page {
    size: A4;
    margin: 80mm 20mm 20mm 20mm; /* bigger top margin for subsequent pages */
  }
  /* Optional: Table styling for print */
  table {
    width: 100% !important;
    border: 1px solid #dee2e6;
    border-collapse: collapse;
  }

  th, td {
    padding: 8px;
    text-align: left;
  }

  /* Report header */
  .report-header {
    display: block !important;
  }

  .report-header h4, .report-header h6 {
    font-size: 12px;
  }
    .print-content {
    display: block;
    page-break-inside: auto;
    padding-top: 10mm; /* adds space for subsequent pages */
  }
}
 `}
        </style>

        {/* Report Header */}
        <div className="pdf-section report-header my-4">
          <div className="text-center mb-3">
            <img
              src="https://externalqcapi.com/media/organization/nhs_logo.webp"
              alt="Logo"
              style={{ height: "60px", marginBottom: "10px" }}
            />

            <h4 style={{ fontWeight: "bold", color: "blue" }}>
              NHS - National External Quality Assessment Scheme
            </h4>
          </div>
          <Row>
            <Row>
              {/* Left Column */}
              <Col md={6}>
                <Row className="mb-2">
                  <Col
                    xs={6}
                    className="text-end"
                    style={{ fontWeight: "bold", color: "black" }}
                  >
                    Participant Number:
                  </Col>
                  <Col xs={6} className="text-left" style={{ color: "blue" }}>
                    {this.props.match.params.id1}
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col
                    xs={6}
                    className="text-end"
                    style={{ fontWeight: "bold", color: "black" }}
                  >
                    Issue Date:
                  </Col>
                  <Col xs={6} className="text-left" style={{ color: "blue" }}>
                    {reportDetails.issueDate}
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col
                    xs={6}
                    className="text-end"
                    style={{ fontWeight: "bold", color: "black" }}
                  >
                    Closing Date:
                  </Col>
                  <Col xs={6} className="text-left" style={{ color: "blue" }}>
                    {reportDetails.closingDate}
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col
                    xs={6}
                    className="text-end"
                    style={{ fontWeight: "bold", color: "black" }}
                  >
                    Print Date:
                  </Col>
                  <Col xs={6} className="text-left" style={{ color: "blue" }}>
                    {reportDetails.printDate}
                  </Col>
                </Row>
              </Col>

              {/* Right Column */}
              <Col md={6}>
                <Row className="mb-2">
                  <Col
                    xs={6}
                    className="text-end"
                    style={{ fontWeight: "bold", color: "black" }}
                  >
                    Scheme:
                  </Col>
                  <Col xs={6} className="text-left" style={{ color: "blue" }}>
                    {reportDetails.scheme}
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col
                    xs={6}
                    className="text-end"
                    style={{ fontWeight: "bold", color: "black" }}
                  >
                    Cycle:
                  </Col>
                  <Col xs={6} className="text-left" style={{ color: "blue" }}>
                    {reportDetails.cycle}
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col
                    xs={6}
                    className="text-end"
                    style={{ fontWeight: "bold", color: "black" }}
                  >
                    Round:
                  </Col>
                  <Col xs={6} className="text-left" style={{ color: "blue" }}>
                    {reportDetails.round}
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col
                    xs={6}
                    className="text-end"
                    style={{ fontWeight: "bold", color: "black" }}
                  >
                    Sample:
                  </Col>
                  <Col xs={6} className="text-left" style={{ color: "blue" }}>
                    {reportDetails.sample}
                  </Col>
                </Row>
              </Col>
            </Row>
          </Row>
        </div>
        <div className="pdf-section">
          {/* Analyte Table */}
          <Table
            bordered
            style={{
              border: "1px solid #dee2e6",
              borderCollapse: "collapse",
              marginTop: "20px",
              marginBottom: "50px",
            }}
          >
            <thead>
              <tr className="text-center">
                {[
                  "Analyte",
                  "Unit",
                  "Instrument",
                  "Count",
                  "Result",
                  "Mean",
                  "Z-Score",
                  "RMZ",
                  "Evaluation",
                ].map((header, idx) => (
                  <th
                    key={idx}
                    style={{
                      border: "1px solid #dee2e6",
                      backgroundColor: "#D0F0FD", // Sky blue color
                    }}
                  >
                    {header}
                  </th>
                ))}
              </tr>
            </thead>

            <tbody>
              {analyteData.map((analyte, index) => (
                <tr key={index}>
                  <td
                    style={{ border: "1px solid #dee2e6", textAlign: "left" }}
                  >
                    {analyte.analyteName}
                  </td>
                  <td
                    style={{ border: "1px solid #dee2e6", textAlign: "center" }}
                  >
                    {analyte.unit}
                  </td>
                  <td
                    style={{ border: "1px solid #dee2e6", textAlign: "left" }}
                  >
                    {analyte.instrument}
                  </td>
                  <td style={{ border: "1px solid #dee2e6" }}>
                    {analyte.count}
                  </td>
                  <td style={{ border: "1px solid #dee2e6" }}>
                    {analyte.result}
                  </td>
                  <td style={{ border: "1px solid #dee2e6" }}>
                    {analyte.robust_mean}
                  </td>
                  <td style={{ border: "1px solid #dee2e6" }}>
                    {analyte.zScore}
                  </td>
                  <td style={{ border: "1px solid #dee2e6" }}>{analyte.CV}</td>
                  <td
                    style={{
                      width: "12.5%",
                      border: "1px solid #dee2e6",
                      color:
                        analyte.evaluation === "Acceptable"
                          ? "green"
                          : analyte.evaluation === "Warning"
                          ? "blue"
                          : analyte.evaluation === "Rejected"
                          ? "red"
                          : "black", // fallback for "Not Submitted" or other values
                      fontWeight: "bold",
                    }}
                  >
                    {analyte.evaluation}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>

        {/* Summary Section */}
        {/* Analyte Details: Dynamically rendered */}
        {/* Summary Section */}

        {/* Analyte Details: Dynamically rendered */}
        <div className="pdf-section">
          {analyteData
            .filter(
              (analyte) => analyte.result !== "--" && analyte.result !== ""
            ) // Filter out analytes without results
            .map((analyte, index) => (
              <div key={index} style={{ marginBottom: "40px" }}>
                {/* Analyte Name - Displayed Outside of the .analyte-box container */}
                <h3>{analyte.analyteName}</h3>

                <div
                  className="analyte-box"
                  style={{
                    display: "flex",
                    gap: "40px",
                    alignItems: "stretch",
                    flexWrap: "wrap",
                  }}
                >
                  {/* Table Section */}
                  <div style={{ flex: "1 1 500px" }}>
                    <Table
                      bordered
                      style={{
                        borderCollapse: "collapse",
                        marginBottom: "20px",
                      }}
                    >
                      <tbody>
                        {/* Row 1 */}
                        <tr>
                          <td
                            style={{
                              width: "16.5%",
                              border: "1px solid #dee2e6",
                              backgroundColor: "#f0f0f0",
                            }}
                          >
                            Robust Mean
                          </td>
                          <td
                            style={{
                              width: "16.5%",
                              border: "1px solid #dee2e6",
                            }}
                          >
                            <strong>{analyte.robust_mean}</strong>
                          </td>
                          <td
                            style={{
                              width: "12.5%",
                              border: "1px solid #dee2e6",
                              backgroundColor: "#f0f0f0",
                            }}
                          >
                            Robust SD
                          </td>
                          <td
                            style={{
                              width: "12.5%",
                              border: "1px solid #dee2e6",
                            }}
                          >
                            <strong>{analyte.robust_sd}</strong>
                          </td>
                        </tr>
                        {/* Row 3 */}
                        <tr>
                          <td
                            style={{
                              width: "12.5%",
                              border: "1px solid #dee2e6",
                              backgroundColor: "#f0f0f0",
                            }}
                          >
                            Accepted Results
                          </td>
                          <td
                            style={{
                              width: "12.5%",
                              border: "1px solid #dee2e6",
                            }}
                          >
                            <strong>{analyte.acceptedResults}</strong>
                          </td>

                          <td
                            style={{
                              width: "12.5%",
                              border: "1px solid #dee2e6",
                              backgroundColor: "#f0f0f0",
                            }}
                          >
                            Rejected Results
                          </td>
                          <td
                            style={{
                              width: "12.5%",
                              border: "1px solid #dee2e6",
                            }}
                          >
                            <strong>{analyte.rejectedResults}</strong>
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              width: "12.5%",
                              border: "1px solid #dee2e6",
                              backgroundColor: "#f0f0f0", // light gray
                            }}
                          >
                            Test Result
                          </td>

                          <td
                            style={{
                              width: "12.5%",
                              border: "1px solid #dee2e6",
                            }}
                          >
                            <strong>{analyte.result}</strong>
                          </td>
                          <td
                            style={{
                              width: "12.5%",
                              border: "1px solid #dee2e6",
                              backgroundColor: "#f0f0f0",
                            }}
                          >
                            Robust Deviation
                          </td>
                          <td
                            style={{
                              width: "12.5%",
                              border: "1px solid #dee2e6",
                            }}
                          >
                            <strong>{analyte.robust_deviation}</strong>
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              width: "12.5%",
                              border: "1px solid #dee2e6",
                              backgroundColor: "#f0f0f0",
                            }}
                          >
                            Z-Score
                          </td>
                          <td
                            style={{
                              width: "12.5%",
                              border: "1px solid #dee2e6",
                            }}
                          >
                            <strong>
                              {analyte.zScore !== undefined
                                ? analyte.zScore
                                : "--"}
                            </strong>
                          </td>
                          <td
                            style={{
                              width: "12.5%",
                              border: "1px solid #dee2e6",
                              backgroundColor: "#f0f0f0",
                            }}
                          >
                            CV (%)
                          </td>
                          <td
                            style={{
                              width: "12.5%",
                              border: "1px solid #dee2e6",
                            }}
                          >
                            <strong>{analyte.CV}</strong>
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              width: "12.5%",
                              border: "1px solid #dee2e6",
                              backgroundColor: "#f0f0f0",
                            }}
                          >
                            Upper Acceptability
                          </td>
                          <td
                            style={{
                              width: "12.5%",
                              border: "1px solid #dee2e6",
                            }}
                          >
                            <strong>{analyte.upper_acceptability_limit}</strong>
                          </td>
                          <td
                            style={{
                              width: "12.5%",
                              border: "1px solid #dee2e6",
                              backgroundColor: "#f0f0f0",
                            }}
                          >
                            Lower Acceptability
                          </td>
                          <td
                            style={{
                              width: "12.5%",
                              border: "1px solid #dee2e6",
                            }}
                          >
                            <strong>{analyte.lower_acceptability_limit}</strong>
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              width: "12.5%",
                              border: "1px solid #dee2e6",
                              backgroundColor: "#f0f0f0",
                            }}
                          >
                            Evaluation
                          </td>
                          <td
                            style={{
                              width: "12.5%",
                              border: "1px solid #dee2e6",
                              color:
                                analyte.evaluation === "Acceptable"
                                  ? "green"
                                  : analyte.evaluation === "Warning"
                                  ? "blue"
                                  : analyte.evaluation === "Rejected"
                                  ? "red"
                                  : "black", // fallback for "Not Submitted" or other values
                              fontWeight: "bold",
                            }}
                          >
                            {analyte.evaluation}
                          </td>

                          <td
                            style={{
                              width: "12.5%",
                              border: "1px solid #dee2e6",
                              backgroundColor: "#f0f0f0",
                            }}
                          >
                            MU(Robust Mean)
                          </td>
                          <td
                            style={{
                              width: "12.5%",
                              border: "1px solid #dee2e6",
                            }}
                          >
                            <strong>{analyte.mu_robust_mean}</strong>
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </div>

                  {/* Graph Section */}
                  <div
                    className="chart-wrapper"
                    style={{
                      flex: "1 1 600px",
                      minWidth: "400px",
                      height: "100%",
                    }}
                  >
                    {(() => {
                      const participantId = this.props.match.params.id1;

                      const graphDataForAnalyte =
                        this.props.reportData.graph_data.find(
                          (g) => g.analyte_name === analyte.analyteName
                        );

                      const allZScores = graphDataForAnalyte
                        ? graphDataForAnalyte.z_scores.map((z) => ({
                            name: `Participant ${z.participant_id}`,
                            id: z.participant_id,
                            ZScore: z.z_score,
                          }))
                        : [];

                      const zScores = allZScores.map((data) => data.ZScore);
                      const groupedZScoreBins = this.groupZScores(zScores);

                      const currentZScore = allZScores.find(
                        (p) => p.id == participantId
                      )?.ZScore;

                      // Find the bin label where the current z-score falls
                      const currentBin = groupedZScoreBins.find((bin) => {
                        const [min, max] = bin.range.split(" to ").map(Number);
                        return currentZScore >= min && currentZScore < max;
                      })?.range;

                      return allZScores.length > 0 ? (
                        <ResponsiveContainer width="100%" height={300}>
                          <BarChart
                            data={groupedZScoreBins}
                            margin={{
                              top: 20,
                              right: 30,
                              left: 20,
                              bottom: 40,
                            }}
                          >
                            <CartesianGrid strokeDasharray="3 3" />

                            <XAxis
                              dataKey="range"
                              tickFormatter={(tick) => {
                                switch (tick) {
                                  case "< -3.0":
                                    return "-3";
                                  case "-3.0 to -2.0":
                                    return "-2";
                                  case "-2.0 to -1.0":
                                    return "-1";
                                  case "-1.0 to +1.0":
                                    return "0";
                                  case "+1.0 to +2.0":
                                    return "1";
                                  case "+2.0 to +3.0":
                                    return "2";
                                  case "> +3.0":
                                    return "3";
                                  default:
                                    return "";
                                }
                              }}
                              label={{
                                value: "Z-Score",
                                position: "insideBottom",
                                offset: -5,
                                style: { textAnchor: "middle", fontSize: 14 },
                              }}
                              style={{ fontSize: "14px" }}
                            />

                            <YAxis
                              allowDecimals={false}
                              label={{
                                value: "Number of Participants",
                                angle: -90,
                                position: "insideLeft",
                                style: { textAnchor: "middle", fontSize: 14 },
                              }}
                            />
                            <Tooltip />
                            <Bar
                              dataKey="count"
                              fill="#3b82f6"
                              radius={[8, 8, 0, 0]}
                            />
                            {currentBin && (
                              <ReferenceLine
                                x={currentBin}
                                stroke="black"
                                strokeWidth={2}
                                label={{
                                  position: "top",
                                  fill: "black",
                                  fontSize: 12,
                                }}
                              />
                            )}
                          </BarChart>
                        </ResponsiveContainer>
                      ) : (
                        <p style={{ color: "red" }}>
                          No Z-Score data available for this analyte.
                        </p>
                      );
                    })()}
                  </div>
                </div>
              </div>
            ))}
        </div>
      </Container>
    );
  }
}

RegReportParticipant.propTypes = {
  match: PropTypes.object,
  reportData: PropTypes.object,
  onGetReport: PropTypes.func,
};

RegReportParticipant.defaultProps = {
  reportData: {},
};

const mapStateToProps = ({ ResultSubmit }) => ({
  reportData: ResultSubmit.Report || {},
});

const mapDispatchToProps = (dispatch) => ({
  onGetReport: (roundId, labId) => dispatch(getReport(roundId, labId)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(RegReportParticipant));
